module.exports = __webpack_public_path__ + "img/title2.c8d787e7.png";